export const extraTextareaProps = {
  placeholder: "Detalii",
  textarea: true,
  nullValue: true,
};
